export default "__VITE_ASSET__rPqj9CdA__"